import Circle from "./Circle";

const CirclesContainer = ({ circlesData }) => {
  return (
    <div className="grid grid-cols-4 gap-6 p-4 gap-x-12">
      {circlesData.map((shape, index) => (
        <Circle key={index} {...shape} />
      ))}
    </div>
  );
};

export default CirclesContainer;
